import { Snapshot } from '@ember-data/store';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class UnavailabilitySerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    // @ts-expect-error - we have no typings for the json api
    delete data.data.attributes.created_by_name;

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    unavailability: UnavailabilitySerializer;
  }
}
